import type { WebSectionId } from "byzantine/src/dbbl/businessLogic/modules/userDisplayPreferences/types";

/**
 * Maps web dashboard section keys (from byzantine's
 * `WEB_DASHBOARD_SECTIONS_LEFT` / `WEB_DASHBOARD_SECTIONS_RIGHT`) to the FTL
 * message ids used for their human-readable labels. Used both for the row
 * text rendered in the customization dialog and for screen-reader drag
 * announcements.
 */
const SECTION_LABELS_TO_FLUENT_IDS: Record<string, string> = {
  balance_charts: "dashboard-customization-section-balance-charts",
  marketing_banner_image:
    "dashboard-customization-section-marketing-banner-image",
  accounts: "dashboard-customization-section-accounts",
  recent_transactions: "dashboard-customization-section-recent-transactions",
  card_offers: "dashboard-customization-section-card-offers",
  quick_transfer: "dashboard-customization-section-quick-transfer",
  account_totals: "dashboard-customization-section-account-totals",
  chart_card: "dashboard-customization-section-chart-card",
  net_worth: "dashboard-customization-section-net-worth",
  credit_monitoring: "dashboard-customization-section-credit-monitoring",
  external_accounts: "dashboard-customization-section-external-accounts",
  verify_external_accounts:
    "dashboard-customization-section-verify-external-accounts",
  marketing_card: "dashboard-customization-section-marketing-card",
  services: "dashboard-customization-section-services",
  subscriptions: "dashboard-customization-section-subscriptions",
  marketing_card_image: "dashboard-customization-section-marketing-card-image",
};

export const SECTION_LABELS_TO_DESCRIPTION_FLUENT_IDS: Record<string, string> =
  {
    balance_charts:
      "dashboard-customization-section-balance-charts-description",
    marketing_banner_image:
      "dashboard-customization-section-marketing-banner-image-description",
    accounts: "dashboard-customization-section-accounts-description",
    recent_transactions:
      "dashboard-customization-section-recent-transactions-description",
    card_offers: "dashboard-customization-section-card-offers-description",
    quick_transfer:
      "dashboard-customization-section-quick-transfer-description",
    account_totals:
      "dashboard-customization-section-account-totals-description",
    chart_card: "dashboard-customization-section-chart-card-description",
    net_worth: "dashboard-customization-section-net-worth-description",
    credit_monitoring:
      "dashboard-customization-section-credit-monitoring-description",
    external_accounts:
      "dashboard-customization-section-external-accounts-description",
    verify_external_accounts:
      "dashboard-customization-section-verify-external-accounts-description",
    marketing_card:
      "dashboard-customization-section-marketing-card-description",
    services: "dashboard-customization-section-services-description",
    subscriptions: "dashboard-customization-section-subscriptions-description",
    marketing_card_image:
      "dashboard-customization-section-marketing-card-image-description",
  } as const;

export const SECTION_LABELS_TO_ICONS: Record<string, string> = {
  balance_charts: "bar-chart",
  marketing_banner_image: "tag",
  accounts: "book",
  recent_transactions: "list",
  card_offers: "award",
  quick_transfer: "transfer-arrows",
  account_totals: "dollar-sign",
  chart_card: "bar-chart",
  net_worth: "trending-up",
  credit_monitoring: "pie-chart",
  external_accounts: "link",
  verify_external_accounts: "check",
  marketing_card: "tag",
  services: "box",
  subscriptions: "calendar",
  marketing_card_image: "image",
} as const;

export const TOTAL_COLUMNS = 2;

export const SECTION_COLUMN_SIZES: Record<WebSectionId, number> = {
  balance_charts: 2,
  marketing_banner_image: 2,
  accounts: 2,
  recent_transactions: 2,
  card_offers: 2,
  quick_transfer: 1,
  account_totals: 1,
  chart_card: 1,
  net_worth: 2,
  credit_monitoring: 1,
  external_accounts: 2,
  verify_external_accounts: 1,
  marketing_card: 1,
  services: 1,
  subscriptions: 1,
  marketing_card_image: 1,
  blank: 1,
} as const;

export default SECTION_LABELS_TO_FLUENT_IDS;
